import React, { useState, forwardRef, useImperativeHandle } from 'react';
import { SubWindow } from '../../../../../components/common/Window';
import { translate } from '@shakkerai/util-i18n';
import { Icon } from '@shakkerai/components';
import { ImageUploadInput } from '@starflow/app/components/atom-input/upload-image';
import { updatePromptFromImage } from '@starflow/app/modules/generator/helpers/reference';
import { Loader } from '@mantine/core';

export const Image2PromptWidow = forwardRef((props, ref) => {
  const { name, uploadedImage, setUploadedImage } = props;
  const [loading, setLoading] = useState(false);
  const positionSetter = () => {
    const entryElementDOM = document.querySelector(`[data-trigger-window="${name}"]`);
    const { x, y } = entryElementDOM.getBoundingClientRect();
    return { x: x, y: y - 500 };
  };
  const handleImage2Prompt = async () => {
    if (uploadedImage?.url && !loading) {
      setLoading(true);
      await updatePromptFromImage(uploadedImage, '', true);
      setLoading(false);
    }
  };

  useImperativeHandle(ref, () => ({
    handleImage2Prompt: handleImage2Prompt,
  }));

  return (
    <SubWindow width={300} height={395} name={name} title={translate('img_to_text')} positionSetter={positionSetter}>
      <div className="w-[300px] h-[350px] flex flex-col">
        <div className="w-[300px] h-[300px]">
          <ImageUploadInput
            height="300px"
            uploadedImage={uploadedImage}
            onImageUploaded={setUploadedImage}
            emptyText={translate('imgadjust_upbutton')}
          />
        </div>
        <div className="h-[50px] flex justify-center items-center">
          <div className="cursor-pointer" onClick={handleImage2Prompt}>
            {loading ? (
              <Loader size={14} color="#5c636b" />
            ) : (
              <Icon fontSize={14} className={`shk-danchuang-zhuanhuantishici text-[#7A7A7A] img-icon `} />
            )}
            <span className="ml-2 item-text text-[12px] text-[#2D2D2D]">{translate('img_prompt')}</span>
          </div>
        </div>
      </div>
    </SubWindow>
  );
});
